import { Injectable } from '@angular/core';
import { LOCALE_DEFAULT, LOCALE_HREF_PREFIX_IGNORELIST } from '@finder/shared/constants/app.constants';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';

@Injectable()
export class LocaleHelperService {
    private uriLocale: string;
    private languageLoadedSubject = new BehaviorSubject<boolean>(false);
    private defaultLocales = LOCALE_HREF_PREFIX_IGNORELIST;

    constructor() { }

    /**
     * [PRO-346388]
     * Announce the locale from the URI has been set
     * @returns Observable<boolean>
     */
    uriLocaleLoaded() {
        return this.languageLoadedSubject.asObservable();
    }

    /**
     * Set the value based on the URI
     * @param value locale value from the URI
     */
    setUriLocale(value: string) {
        this.uriLocale = value;

        // [PRO-346388] Let anyone listening know the language has been loaded
        this.languageLoadedSubject.next(true);
    }

    /**
     * Return the locale value from the URI
     * @returns {string}
     */
    getUriLocale() {
        return this.uriLocale;
    }

    /**
     * Strips the current locale of a url.
     * Ex: input: /es-us/attractions/magic-kingdom/space-mountain
     *     outpu: /attractions/magic-kingdom/space-mountain
     * @param url the url
     */
    stripLocale(url) {
        const uriLocale = this.getUriLocale();
        if (url && url.indexOf(uriLocale) !== -1) {
            url = url.replace(uriLocale, '');
            // remove repeated slashes.
            url = url.replace('//', '/');
        }
        return url;
    }

    /**
     * Check to see if this is a default english locale
     */
    isDefaultLocale(locale) {
        locale = locale || LOCALE_DEFAULT;
        return this.defaultLocales.includes(this.getNormalizedLocale(locale));
    }

    /**
     * Normalize the locale string to `xx-xx` format to make it easier to parse
     */
    getNormalizedLocale(locale): string {
        if (!locale) {
            locale = LOCALE_DEFAULT;
        }
        return locale.toLowerCase().replace('_', '-');
    }

}
